import { fieldRequiredMessage, incorrectIprIdMessage } from 'assets/messages/errorMessages';
import { Button } from 'components/UI/Button/Button';
import { StyledFormError } from 'components/UI/FormError/StyledFormError';

import { StyledTextInput } from 'components/UI/InputElements/StyledTextInput';
import { StyledTextLabel } from 'components/UI/TextLabel/StyledTextLabel';
import { FormEventHandler } from 'react';
import { FieldError, UseFormRegister } from 'react-hook-form';
import { autofillG4ComboardId } from 'utils/formsUtils/formsUtils';

export interface FormInput {
  iprId: string;
}
export interface FormErrors {
  iprId?: FieldError;
}
interface Props {
  onSubmit: FormEventHandler<HTMLFormElement>;
  register: UseFormRegister<FormInput>;
  errors: FormErrors;
  placeholder?: string;
}

export const CopyIprIdToQaForm = ({ onSubmit, register, errors }: Props) => {
  return (
    <form onSubmit={onSubmit}>
      <StyledTextLabel htmlFor="iprId">Ipr Id:</StyledTextLabel>
      <StyledTextInput
        {...register('iprId', {
          required: {
            value: true,
            message: fieldRequiredMessage,
          },
          setValueAs: autofillG4ComboardId(),
          pattern: {
            value: /^[a-zA-Z0-9]{8}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{12}$/,
            message: incorrectIprIdMessage,
          },
        })}
        placeholder="a1a1a1a1-a1a1-a1a1-a1a1-a1a1a1a1a1a1"
      />
      {errors.iprId && <StyledFormError>{errors.iprId.message}</StyledFormError>}
      <Button type="submit">Send</Button>
    </form>
  );
};
